import { jsxs as v, jsx as e } from "react/jsx-runtime";
import { useState as f } from "react";
import { MobileMenuModal as a } from "../mobile-menu-modal/mobile-menu-modal.js";
import d from "../mobile-first-level-menu/mobile-first-level-menu.js";
import b from "../mobile-second-level-menu/mobile-second-level-menu.js";
import { useTranslation as h } from "react-i18next";
const A = ({
  menuItems: i,
  featureLinks: s,
  isOpen: l,
  portalContainer: r,
  onClickClose: t
}) => {
  const [o, n] = f(null), c = o !== null ? i[o] : null, { t: u } = h(), m = `${u("HEADER_MENU")} level 1`, M = `${u("HEADER_MENU")} level 2`;
  return /* @__PURE__ */ v("div", { children: [
    /* @__PURE__ */ e(
      a,
      {
        portalContainer: r,
        anchor: "bottom",
        isOpen: l,
        close: { function: t },
        title: m,
        children: /* @__PURE__ */ e(
          d,
          {
            menuItems: i,
            featureLinks: s,
            onClickClose: t,
            onClickCategory: n
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      a,
      {
        portalContainer: r,
        anchor: l ? "right" : "bottom",
        isOpen: l && o !== null,
        close: { function: t },
        title: M,
        children: /* @__PURE__ */ e(
          b,
          {
            title: c?.title,
            menuItems: c?.links,
            onClickClose: () => {
              n(null), t();
            },
            onClickBack: () => n(null)
          }
        )
      }
    )
  ] });
};
export {
  A as default
};
